export default {
  newDesign: true,
  parameters: {
    landing_id: "SpQSI",
    segment: 54,
  },
  title: "Responde estas 5 preguntas y recibe una clase gratuita para tu hijo/a | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      type: "age-start",
      title: "¿Cuántos años tiene tu hijo?",
      image: {
        url: "/welcome/peru_1_start_immediate_desk.png",
      },
      imageMobile: {
        url: "/welcome/peru_1_start_immediate_mob.png",
      },
    },
    2: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
    },
    3: {
      question: "¿Cuál es la materia favorita de tu hijo/a en la escuela?",
      answers: [
        "Español",
        "Matemáticas",
        "Ciencias naturales",
        "Historia",
        "Geografía",
        "Arte",
        "Educación física",
        "Otro"
      ],
    },
    4: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    5: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    6: {
      title: "¡Felicitaciones! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Haz clic en '📆 Reservar una clase' para completar el registro",
      button: "📆 Reservar una clase",
    },
    7: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo tienes que hacer clic en el enlace, te llevará directamente a la clase. Sin aplicaciones adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
